module.exports = __webpack_public_path__ + "img/vedioMoRen.1641520899224.png";